<template>
  <div class="amc-profile-container">
    <el-card class="profile-card">
      <div slot="header" class="card-header">
        <span class="title">个人中心</span>
        <div v-if="showCourseContextHeader" class="header-actions">
          <el-button type="text" size="mini" @click="recreatePlan">
            <i class="el-icon-refresh"></i> 重新制定计划
          </el-button>
          <el-button type="text" size="mini" @click="goBackToAMCCourse">
            <i class="el-icon-back"></i> 返回备考中心
          </el-button>
        </div>
      </div>

      <div v-if="showCourseContextHeader" class="header-amc-bar">
        <div class="header-amc-item">
          <span class="header-amc-label">等级</span>
          <span class="header-amc-value">{{ amcLevelDisplay || '—' }}</span>
        </div>
        <div class="header-amc-item">
          <span class="header-amc-label">备考年份</span>
          <span class="header-amc-value">{{ amcYearDisplay || '—' }}</span>
        </div>
        <div class="header-amc-item">
          <span class="header-amc-label">会员状态</span>
          <span class="header-amc-value" :class="{ 'status-paid': isMember, 'status-unpaid': !isMember }">
            {{ isMember ? '已开通' : '未开通' }}
          </span>
        </div>
        <div class="header-amc-item points-item" @click="showRechargeDialog = true">
          <span class="header-amc-label">我的积分</span>
          <span class="header-amc-value points-value">
            <i class="el-icon-coin"></i> {{ pointsBalance }}
          </span>
          <span class="recharge-btn">充值</span>
        </div>
      </div>

      <!-- 未开通会员提示 -->
      <div class="purchase-tip" v-if="showCourseContextHeader && !isMember">
        <el-alert
          :title="`您尚未开通${courseTypeTitle()}会员`"
          type="warning"
          :closable="false"
          show-icon>
          <div slot="description">
            <p>开通会员后可解锁全部精品课程内容，包括视频课程、学习资料、专属答疑等。</p>
            <el-button type="primary" size="small" @click="showPurchaseDialog = true" style="margin-top: 10px;">
              <i class="el-icon-medal"></i> 立即开通
            </el-button>
          </div>
        </el-alert>
      </div>

      <div class="profile-content" v-loading="loading">
        <!-- AMC信息区域 -->
        <!-- <div class="amc-info-section">
          <div class="section-title">AMC备考信息</div>
          <div class="amc-info-row">
            <div class="info-item">
              <span class="label">AMC等级</span>
              <span class="value">{{ amcLevelDisplay || '—' }}</span>
            </div>
            <div class="info-item">
              <span class="label">备考年份</span>
              <span class="value">{{ amcYearDisplay || '—' }}</span>
            </div>
          </div>
        </div> -->

        <!-- 个人信息表单 -->
        <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px" class="user-form">
          <div class="section-title">基本信息</div>

          <el-form-item label="头像">
            <div class="avatar-container" @click="fileDialogVisible = true">
              <img :src="avatarUrl" class="user-avatar" @error="handleAvatarError">
              <div class="avatar-overlay">
                <i class="el-icon-camera"></i>
                <span>点击更换</span>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="姓名" prop="realName">
            <el-input v-model="userForm.realName" placeholder="请输入姓名"></el-input>
          </el-form-item>

          <el-form-item label="性别" prop="gender">
            <el-radio-group v-model="userForm.gender">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="出生日期" prop="birthday">
            <el-date-picker v-model="userForm.birthday" type="date" placeholder="选择日期" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="城市" prop="department">
            <el-input v-model="userForm.department" placeholder="未填写"></el-input>
          </el-form-item>

          <el-form-item label="学校" prop="school">
            <el-input v-model="userForm.school" placeholder="未填写"></el-input>
          </el-form-item>

          <el-form-item label="年级" prop="major">
            <el-input v-model="userForm.major" placeholder="未填写"></el-input>
          </el-form-item>

          <el-form-item label="账号" prop="userName">
            <el-input v-model="userForm.userName" placeholder="请输入账号" :disabled="true"></el-input>
          </el-form-item>

          <el-form-item label="联系方式" prop="phone">
            <div style="display: flex; gap: 10px;">
              <el-input v-model="userForm.phone" placeholder="未绑定" :disabled="true"></el-input>
              <el-button type="primary" plain @click="openBindPhoneDialog">
                {{ userForm.phone ? '更换' : '绑定' }}
              </el-button>
            </div>
          </el-form-item>

          <el-form-item label="邮箱" prop="email">
            <div style="display: flex; gap: 10px;">
              <el-input v-model="userForm.email" placeholder="未绑定" :disabled="true"></el-input>
              <el-button type="primary" plain @click="openBindEmailDialog">
                {{ userForm.email ? '更换' : '绑定' }}
              </el-button>
            </div>
          </el-form-item>

          <el-form-item label="机构码">
            <div class="org-bind-row">
              <el-input
                v-model="orgPromoCode"
                placeholder="请输入机构码"
                clearable
                @keyup.enter.native="handleBindOrgCode"
              ></el-input>
              <el-button type="primary" :loading="orgBinding" @click="handleBindOrgCode">
                绑定机构
              </el-button>
            </div>
            <div class="org-bind-tip">一个用户可绑定多个机构，重复绑定同一家机构会提示已绑定。</div>
            <div class="org-binding-list" v-loading="orgBindingsLoading">
              <div v-if="!myOrganizations.length" class="org-empty">暂未绑定任何机构</div>
              <div v-else>
                <div v-for="item in myOrganizations" :key="item.id" class="org-binding-item">
                  <div class="org-binding-main">
                    <div class="org-binding-name">{{ item.orgName || '未命名机构' }}</div>
                    <div class="org-binding-meta">
                      <span>机构码：{{ item.promoCode || '-' }}</span>
                      <span v-if="item.contactName">联系人：{{ item.contactName }}</span>
                      <span v-if="item.contactPhone">电话：{{ item.contactPhone }}</span>
                    </div>
                  </div>
                  <div class="org-binding-time">{{ formatDateTime(item.bindTime) }}</div>
                </div>
              </div>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('userForm')" :loading="loading">保存</el-button>
            <el-button @click="goBackToAMCCourse">返回</el-button>
            <el-button type="danger" plain @click="showDeleteAccountDialog" style="margin-left: 20px">注销账户</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <!-- 上传头像对话框 -->
    <el-dialog width="400px" :show-close="false" :close-on-click-modal="false" title="上传头像"
      :visible.sync="fileDialogVisible">
      <el-upload class="upload-demo" drag action="xxxxxx" multiple :limit="1" accept="png, jpg, jpeg, bmp"
        :auto-upload="false" :on-remove="handleRemove" :on-change="handleFileChange" :file-list="fileList">
        <i class="el-icon-upload" />
        <div class="el-upload__text">
          将文件拖到此处，或<em>点击上传</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          只能上传"png", "jpg", "jpeg", "bmp"文件，且不超过2MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fileDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="importAvatar">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 绑定邮箱弹窗 -->
    <el-dialog
      title="绑定邮箱"
      :visible.sync="bindEmailDialogVisible"
      width="480px"
      :close-on-click-modal="false">
      <el-form :model="bindEmailForm" ref="bindEmailForm" label-width="100px">
        <el-form-item label="邮箱">
          <el-input v-model="bindEmailForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <div style="display: flex; gap: 10px;">
            <el-input v-model="bindEmailForm.code" placeholder="请输入6位验证码" maxlength="6"></el-input>
            <el-button
              type="primary"
              :disabled="bindEmailCodeSending || bindEmailCountdown > 0"
              :loading="bindEmailCodeSending"
              @click="sendBindEmailCodeFn">
              {{ bindEmailCountdown > 0 ? `${bindEmailCountdown}秒后重试` : '发送验证码' }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindEmailDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="bindEmailSubmitting" @click="submitBindEmail">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 注销账户对话框 -->
    <el-dialog
      title="注销账户"
      :visible.sync="deleteAccountDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :before-close="handleDeleteAccountDialogClose">
      <div class="delete-account-dialog">
        <el-alert
          title="危险操作警告"
          type="error"
          :closable="false"
          show-icon
          style="margin-bottom: 20px;">
          <div slot="description">
            <p style="font-weight: bold; margin-bottom: 8px;">注销账户将删除以下所有数据，此操作不可恢复：</p>
            <ul style="margin: 0; padding-left: 20px; line-height: 1.8;">
              <li>个人基本信息</li>
              <li>AMC学习记录和进度</li>
              <li>学习计划和方案</li>
              <li>答题记录和成绩</li>
              <li>其他相关数据</li>
            </ul>
            <p style="margin-top: 12px; color: #f56c6c; font-weight: bold;">请谨慎操作！</p>
          </div>
        </el-alert>

        <div v-if="userForm.email" style="margin-bottom: 20px;">
          <p style="font-size: 14px; color: #606266; margin-bottom: 10px;">
            验证码将发送至绑定邮箱：<span style="font-weight: bold;">{{ userForm.email }}</span>
          </p>
        </div>
        <div v-else style="margin-bottom: 20px;">
          <el-alert
            title="未绑定邮箱"
            type="warning"
            :closable="false"
            show-icon>
            <div slot="description">
              请先绑定邮箱后再进行注销操作
            </div>
          </el-alert>
        </div>

        <el-form :model="deleteAccountForm" :rules="deleteAccountRules" ref="deleteAccountForm" label-width="100px">
          <el-form-item label="验证码" prop="code">
            <div style="display: flex; gap: 10px;">
              <el-input
                v-model="deleteAccountForm.code"
                placeholder="请输入6位验证码"
                maxlength="6"
                :disabled="!userForm.email || deleteAccountLoading">
              </el-input>
              <el-button
                type="primary"
                :disabled="!userForm.email || deleteAccountCodeSending || deleteAccountCountdown > 0"
                :loading="deleteAccountCodeSending"
                @click="sendDeleteAccountCodeHandler"
                style="min-width: 120px;">
                {{ deleteAccountCountdown > 0 ? `${deleteAccountCountdown}秒后重试` : '发送验证码' }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDeleteAccountDialogClose" :disabled="deleteAccountLoading">取 消</el-button>
        <el-button type="danger" @click="submitDeleteAccount" :loading="deleteAccountLoading" :disabled="!userForm.email">确认注销</el-button>
      </div>
    </el-dialog>

    <!-- 购买弹窗 -->
    <amc-purchase-dialog
      :visible.sync="showPurchaseDialog"
      :course-type="courseTypeTitle()"
      :course-level="resolveMembershipSubjectCode() || ''"
      :course-display-name="courseTypeTitle()"
      @purchased="handlePurchased">
    </amc-purchase-dialog>

    <!-- 绑定手机号弹窗 -->
    <el-dialog
      title="绑定手机号"
      :visible.sync="bindPhoneDialogVisible"
      width="480px"
      :close-on-click-modal="false">
      <el-form :model="bindPhoneForm" ref="bindPhoneForm" label-width="100px">
        <el-form-item label="手机号">
          <el-input v-model="bindPhoneForm.phone" placeholder="请输入手机号" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="验证码">
          <div style="display: flex; gap: 10px;">
            <el-input v-model="bindPhoneForm.code" placeholder="请输入6位验证码" maxlength="6"></el-input>
            <el-button
              type="primary"
              :disabled="bindPhoneCodeSending || bindPhoneCountdown > 0"
              :loading="bindPhoneCodeSending"
              @click="sendBindPhoneCodeFn">
              {{ bindPhoneCountdown > 0 ? `${bindPhoneCountdown}秒后重试` : '发送验证码' }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bindPhoneDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="bindPhoneSubmitting" @click="submitBindPhone">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 积分充值弹窗 -->
    <points-recharge-dialog
      :visible.sync="showRechargeDialog"
      @recharged="handleRecharged">
    </points-recharge-dialog>
  </div>
</template>

<script>
 import {
   uploadAvatar,
   getUserInfo,
   updateUserInfo,
   sendDeleteAccountCode,
   deleteAccount,
   sendBindEmailCode,
   bindEmail,
   sendBindPhoneCode,
   bindPhone,
   userAddClass,
   trackPresence
 } from '@/api/user'
 import { getTokenInfo } from '@/utils/jwtUtils'
 import { getActivePlan, getPlansByUserId } from '@/api/studyPlan'
 import { getPointsBalance } from '@/api/points'
 import { getMyUserMembership } from '@/api/userMembership'
 import { bindMyPromoCode, getMyOrganizations } from '@/api/organization'
 import AmcPurchaseDialog from '@/components/AmcPurchaseDialog.vue'
 import PointsRechargeDialog from '@/components/PointsRechargeDialog.vue'

 export default {
   name: 'AmcProfile',
   components: {
     AmcPurchaseDialog,
     PointsRechargeDialog
   },
   data() {
     return {
      loading: false,
      isMember: false,
      showPurchaseDialog: false,
      fileDialogVisible: false,
      fileList: [],
      data: {},
      defaultAvatar: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIGZpbGw9IiNFNUU3RUIiLz4KPHN2ZyB4PSI4IiB5PSI4IiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDEyQzE0LjIwOTEgMTIgMTYgMTAuMjA5MSAxNiA4QzE2IDUuNzkwODYgMTQuMjA5MSA0IDEyIDRDOS43OTA4NiA0IDggNS43OTA4NiA4IDhDOCAxMC4yMDkxIDkuNzkwODYgMTIgMTIgMTJaIiBmaWxsPSIjOUM5QzlDIi8+CjxwYXRoIGQ9Ik0xMiAxNEM5LjMzIDE0IDcuMDEgMTUuMjQgNS4zNiAxNy4yNEM2LjY3IDE5LjI0IDkuMTkgMjAgMTIgMjBDMTQuODEgMjAgMTcuMzMgMTkuMjQgMTguNjQgMTcuMjRDMTYuOTkgMTUuMjQgMTQuNjcgMTQgMTIgMTRaIiBmaWxsPSIjOUM5QzlDIi8+Cjwvc3ZnPgo8L3N2Zz4K',
      userForm: {
        realName: '',
        gender: '',
        birthday: '',
        department: '',
        school: '',
        major: '',
        userName: '',
        phone: '',
        email: ''
      },
      rules: {
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        phone: [
          { required: false, message: '请输入联系方式', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: false, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      amcLevelDisplay: '',
      amcYearDisplay: '',
      showRechargeDialog: false,
      pointsBalance: 0,
      orgPromoCode: '',
      orgBinding: false,
      orgBindingsLoading: false,
      myOrganizations: [],
      bindPhoneDialogVisible: false,
      bindPhoneForm: {
        phone: '',
        code: ''
      },
      bindPhoneCodeSending: false,
      bindPhoneCountdown: 0,
      bindPhoneTimer: null,
      bindPhoneSubmitting: false,
      bindEmailDialogVisible: false,
      bindEmailForm: {
        email: '',
        code: ''
      },
      bindEmailCodeSending: false,
      bindEmailCountdown: 0,
      bindEmailTimer: null,
      bindEmailSubmitting: false,
      deleteAccountDialogVisible: false,
      deleteAccountLoading: false,
      deleteAccountCodeSending: false,
      deleteAccountCountdown: 0,
      deleteAccountForm: {
        code: ''
      },
      deleteAccountRules: {
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '请输入6位数字验证码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.loadCourseMeta()
    this.fetchUserInfo()
    this.checkMemberStatus()
    this.loadPointsBalance()
    this.loadMyOrganizations()
  },
  mounted() {
    try {
      this.$store && this.$store.dispatch && this.$store.dispatch('app/closeSideBar', { withoutAnimation: true })
    } catch (e) {}
  },
  beforeDestroy() {
    try {
      this.$store && this.$store.dispatch && this.$store.dispatch('app/openSideBar', { withoutAnimation: true })
    } catch (e) {}

    if (this.bindPhoneTimer) {
      clearInterval(this.bindPhoneTimer)
    }
    if (this.bindEmailTimer) {
      clearInterval(this.bindEmailTimer)
    }
  },
  computed: {
    showCourseContextHeader() {
      const q = (this.$route && this.$route.query) ? this.$route.query : {}
      return !!(q.level || q.courseTypeCode || q.courseTypeId || q.repoId)
    },
    avatarUrl() {
      const { getUserAvatarUrl } = require('@/utils/minio')
      const avatarUrl = this.data && this.data.avatar ? this.data.avatar : ''
      const processedUrl = getUserAvatarUrl(avatarUrl)
      return processedUrl || this.defaultAvatar
    }
  },
  methods: {
    courseTypeTitle() {
      const q = (this.$route && this.$route.query) ? this.$route.query : {}
      const t = String(q.courseTypeCode || 'AMC').trim()
      return t ? t.toUpperCase() : 'AMC'
    },
    normalizeMembershipSubjectCode(subjectCode, courseType) {
      const raw = String(subjectCode || '').trim()
      if (!raw) return undefined
      const ct = String(courseType || '').trim().toUpperCase()
      const upper = raw.toUpperCase().replace(/\s+/g, '')
      if (ct === 'GESP' || upper.includes('GESP')) {
        const match = upper.match(/LEVEL(\d+)/) || upper.match(/^GESP(\d+)$/) || upper.match(/GESP.*?(\d+)/)
        if (match && match[1]) return `GESPLEVEL${match[1]}`
        return upper.replace(/^CCF-/, '')
      }
      return raw.toUpperCase()
    },
    resolveMembershipSubjectCode() {
      const q = (this.$route && this.$route.query) ? this.$route.query : {}
      const courseType = String(q.courseTypeCode || 'AMC').trim().toUpperCase()
      const routeLevel = String(q.level || '').trim()
      if (routeLevel) return this.normalizeMembershipSubjectCode(routeLevel, courseType)
      const displayLevel = String(this.amcLevelDisplay || '').trim()
      if (!displayLevel) return undefined
      return this.normalizeMembershipSubjectCode(displayLevel, courseType)
    },
    async loadCourseMeta() {
      // 优先使用路由透传的课程上下文（支持袋鼠等非 AMC）
      const q = (this.$route && this.$route.query) ? this.$route.query : {}
      const qLevel = q.level != null ? String(q.level).trim() : ''
      const qCourseTypeCode = q.courseTypeCode != null ? String(q.courseTypeCode).trim() : ''

      // 兜底：旧逻辑仍保留 amc_user_selection（仅 AMC）
      try {
        const selection = JSON.parse(localStorage.getItem('amc_user_selection') || 'null')
        if (selection) {
          const lv = selection.level != null ? String(selection.level).trim() : ''
          if (!qLevel && lv) this.amcLevelDisplay = this.normalizeAmcLevelDisplay(lv) || this.amcLevelDisplay
          if (selection.year != null && String(selection.year).trim() !== '') {
            this.amcYearDisplay = String(selection.year)
          }
        }
      } catch (e) {}

      if (qLevel) {
        this.amcLevelDisplay = this.normalizeAmcLevelDisplay(qLevel) || qLevel
      }

      // 从通用学习计划接口中补全“备考年份”等信息
      try {
        const tokenInfo = getTokenInfo && getTokenInfo()
        const userId = tokenInfo ? tokenInfo.id : null
        if (!userId) return

        const courseType = qCourseTypeCode ? String(qCourseTypeCode).toUpperCase() : undefined
        const activeRes = await getActivePlan(userId, courseType).catch(() => null)
        const activePlan = activeRes && (activeRes.data !== undefined ? activeRes.data : activeRes)
        if (activePlan && activePlan.targetYear != null) {
          this.amcYearDisplay = String(activePlan.targetYear)
          return
        }

        const plansRes = await getPlansByUserId(userId).catch(() => null)
        const list = plansRes?.data
        const plans = Array.isArray(list) ? list : []
        const filtered = courseType
          ? plans.filter(p => String(p?.courseType || '').toUpperCase() === courseType)
          : plans
        const picked = filtered.find(p => Number(p?.isActive) === 1) || filtered[0]
        if (picked && picked.targetYear != null) {
          this.amcYearDisplay = String(picked.targetYear)
        }
      } catch (e) {
        // 静默失败：继续使用 localStorage 的兜底值
      }
    },
    // 检查会员状态
    async checkMemberStatus() {
      try {
        const tokenInfo = getTokenInfo && getTokenInfo()
        const userId = tokenInfo ? tokenInfo.id : null
        if (!userId) return

        const q = (this.$route && this.$route.query) ? this.$route.query : {}
        const courseTypeCode = String(q.courseTypeCode || 'AMC').trim().toUpperCase()
        const subjectCode = this.resolveMembershipSubjectCode()
        const res = await getMyUserMembership({ courseTypeCode, subjectCode: subjectCode || undefined })
        const membership = (res && res.code === 1) ? res.data : null
        this.isMember = !!(membership && String(membership.tierCode || '').toUpperCase() === 'VIP')
      } catch (e) {
        console.error('检查会员状态失败:', e)
        this.isMember = false
      }
    },
    // 开通会员成功回调
    handlePurchased() {
      this.isMember = true
      this.showPurchaseDialog = false
      this.$message.success(`开通成功！您已成为${this.courseTypeTitle()}会员`)
    },
    // 加载积分余额
    async loadPointsBalance() {
      try {
        const tokenInfo = getTokenInfo && getTokenInfo()
        const userId = tokenInfo ? tokenInfo.id : null
        if (!userId) return

        const res = await getPointsBalance(userId)
        if (res && res.code === 1) {
          this.pointsBalance = res.data || 0
        }
      } catch (e) {
        console.error('获取积分余额失败:', e)
      }
    },
    // 充值成功回调
    handleRecharged(data) {
      if (data && data.balance != null) {
        this.pointsBalance = data.balance
      } else {
        this.loadPointsBalance()
      }
    },

    formatDateTime(value) {
      if (!value) return '-'
      const s = String(value)
      return s.length >= 19 ? s.slice(0, 19).replace('T', ' ') : s.replace('T', ' ')
    },

    async loadMyOrganizations() {
      this.orgBindingsLoading = true
      try {
        const res = await getMyOrganizations()
        this.myOrganizations = (res && res.code === 1 && Array.isArray(res.data)) ? res.data : []
      } catch (e) {
        console.error('加载机构绑定列表失败:', e)
        this.myOrganizations = []
      } finally {
        this.orgBindingsLoading = false
      }
    },

    async handleBindOrgCode() {
      const code = String(this.orgPromoCode || '').trim()
      if (!code) {
        this.$message.warning('请输入机构码')
        return
      }
      this.orgBinding = true
      try {
        const res = await bindMyPromoCode(code)
        if (res && res.code === 1) {
          this.$message.success(res.msg || '机构绑定成功')
          this.orgPromoCode = ''
          this.loadMyOrganizations()
        } else {
          this.$message.error((res && res.msg) || '机构绑定失败')
        }
      } catch (e) {
        console.error('机构绑定失败:', e)
        this.$message.error('机构绑定失败，请重试')
      } finally {
        this.orgBinding = false
      }
    },

    openBindPhoneDialog() {
      this.bindPhoneForm.phone = this.userForm.phone || ''
      this.bindPhoneForm.code = ''
      this.bindPhoneDialogVisible = true
    },

    openBindEmailDialog() {
      this.bindEmailForm.email = this.userForm.email || ''
      this.bindEmailForm.code = ''
      this.bindEmailDialogVisible = true
    },

    async sendBindEmailCodeFn() {
      const email = (this.bindEmailForm.email || '').trim()
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailReg.test(email)) {
        this.$message.warning('请输入正确的邮箱地址')
        return
      }

      this.bindEmailCodeSending = true
      try {
        const res = await sendBindEmailCode(email)
        if (res && res.code) {
          this.$message.success('验证码已发送，请查收邮箱')
          this.bindEmailCountdown = 60
          if (this.bindEmailTimer) clearInterval(this.bindEmailTimer)
          this.bindEmailTimer = setInterval(() => {
            this.bindEmailCountdown--
            if (this.bindEmailCountdown <= 0) {
              clearInterval(this.bindEmailTimer)
              this.bindEmailTimer = null
              this.bindEmailCountdown = 0
            }
          }, 1000)
        } else {
          this.$message.error((res && res.msg) || '验证码发送失败')
        }
      } catch (e) {
        console.error('发送邮箱验证码失败:', e)
        this.$message.error('验证码发送失败，请重试')
      } finally {
        this.bindEmailCodeSending = false
      }
    },

    async submitBindEmail() {
      const email = (this.bindEmailForm.email || '').trim()
      const code = (this.bindEmailForm.code || '').trim()
      if (!email) {
        this.$message.warning('请输入邮箱')
        return
      }
      if (!code) {
        this.$message.warning('请输入验证码')
        return
      }

      this.bindEmailSubmitting = true
      try {
        const res = await bindEmail(email, code)
        if (res && res.code) {
          this.$message.success('邮箱绑定成功')
          this.userForm.email = email
          this.bindEmailDialogVisible = false
        } else {
          this.$message.error((res && res.msg) || '绑定失败')
        }
      } catch (e) {
        console.error('绑定邮箱失败:', e)
        this.$message.error('绑定失败，请重试')
      } finally {
        this.bindEmailSubmitting = false
      }
    },

    async sendBindPhoneCodeFn() {
      const phone = (this.bindPhoneForm.phone || '').trim()
      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(phone)) {
        this.$message.warning('请输入正确的手机号')
        return
      }

      this.bindPhoneCodeSending = true
      try {
        const res = await sendBindPhoneCode(phone)
        if (res && res.code) {
          this.$message.success('验证码已发送，请查收')
          this.bindPhoneCountdown = 60
          this.bindPhoneTimer = setInterval(() => {
            this.bindPhoneCountdown--
            if (this.bindPhoneCountdown <= 0) {
              clearInterval(this.bindPhoneTimer)
              this.bindPhoneTimer = null
              this.bindPhoneCodeSending = false
            }
          }, 1000)
        } else {
          this.$message.error((res && res.msg) || '发送失败')
          this.bindPhoneCodeSending = false
        }
      } catch (e) {
        console.error('发送绑定手机号验证码失败:', e)
        this.$message.error('发送失败，请稍后重试')
        this.bindPhoneCodeSending = false
      }
    },

    async submitBindPhone() {
      const phone = (this.bindPhoneForm.phone || '').trim()
      const code = (this.bindPhoneForm.code || '').trim()
      if (!phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (!code) {
        this.$message.warning('请输入验证码')
        return
      }

      this.bindPhoneSubmitting = true
      try {
        const res = await bindPhone(phone, code)
        if (res && res.code) {
          this.$message.success('手机号绑定成功')
          this.userForm.phone = phone
          this.bindPhoneDialogVisible = false
        } else {
          this.$message.error((res && res.msg) || '绑定失败')
        }
      } catch (e) {
        console.error('绑定手机号失败:', e)
        this.$message.error('绑定失败，请重试')
      } finally {
        this.bindPhoneSubmitting = false
      }
    },
    normalizeAmcLevelDisplay(level) {
      if (!level) return ''
      // 数字 repoId/amcRepo: 14/15/16
      if (typeof level === 'number' || /^\d+$/.test(String(level).trim())) {
        const n = Number(level)
        const numMap = {
          14: 'AMC 8',
          15: 'AMC 10',
          16: 'AMC 12'
        }
        return numMap[n] || String(level)
      }
      const v = String(level).trim()
      const key = v.toLowerCase().replace(/\s+/g, '')
      const map = {
        amc8: 'AMC 8',
        amc10: 'AMC 10',
        amc12: 'AMC 12'
      }
      if (map[key]) return map[key]
      // 兼容有些地方可能存的是 AMC8/AMC10/AMC12
      const key2 = key.replace('amc', 'amc')
      return map[key2] || v
    },
    extractYearFromExamDate(examDate) {
      if (!examDate) return ''
      // 兼容字符串："yyyy-MM-dd HH:mm:ss" 或 "yyyy-MM-dd"
      if (typeof examDate === 'string') {
        const m = examDate.match(/^(\d{4})-/)
        return m ? m[1] : ''
      }
      // 若后端以对象传递（极少数情况），尝试 Date
      try {
        const d = new Date(examDate)
        if (!isNaN(d.getTime())) return String(d.getFullYear())
      } catch (e) {}
      return ''
    },
    fetchUserInfo() {
      this.loading = true
      getUserInfo().then(response => {
        const { data } = response
        if (data) {
          this.data = data
          this.userForm = {
            realName: data.realName || '',
            gender: data.gender !== undefined && data.gender !== null ? Number(data.gender) : 1,
            birthday: data.birthday || '',
            department: data.department || '',
            school: data.school || '',
            major: data.major || '',
            userName: data.userName || '',
            phone: data.phone || '',
            email: data.email || ''
          }
        }
        this.loading = false
      }).catch(error => {
        console.error('获取用户信息失败', error)
        this.loading = false
        this.$message.error('获取用户信息失败')
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.loading = true
          updateUserInfo(this.userForm).then(response => {
            if (response.code) {
              this.$message.success('保存成功')
              this.fetchUserInfo()
            } else {
              this.$message.error(response.msg || '保存失败')
            }
            this.loading = false
          }).catch(error => {
            console.error('更新用户信息失败', error)
            this.loading = false
            this.$message.error('更新用户信息失败')
          })
        } else {
          return false
        }
      })
    },
    goBackToAMCCourse() {
      const q = (this.$route && this.$route.query) ? this.$route.query : {}
      this.$router.push({
        path: '/amc-course',
        query: {
          level: q.level,
          courseTypeId: q.courseTypeId,
          courseTypeCode: q.courseTypeCode
        }
      })
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.hasFiles = false
      }
    },
    importAvatar() {
      if (this.fileList.length > 0) {
        const formData = new FormData()
        formData.append('file', this.fileList[0].raw)
        uploadAvatar(formData)
          .then((res) => {
            if (res.code) {
              if (res.data) {
                this.data.avatar = res.data
              }
              this.fetchUserInfo()
              this.$store.dispatch('user/getInfo')
              this.$message.success('头像上传成功！')
              this.fileDialogVisible = false
              this.fileList = []
            } else {
              this.$message.error(res.msg || '头像上传失败！')
            }
          })
          .catch((error) => {
            console.error('文件上传失败：', error)
            this.$message.error('文件上传失败！')
          })
      } else {
        this.$message.warning('请选择文件后再上传！')
      }
    },
    handleAvatarError(event) {
      event.target.src = this.defaultAvatar
    },
    async recreatePlan() {
      // 单步弹窗：直接在同一个确认框中选择“清除记录/保留记录”
      // $confirm: 点确定→resolve, 点取消按钮→reject('cancel'), 点×→reject('close')
      let clearRecords = true
      try {
        await this.$confirm(
          '重新制定学习计划后，将清除当前学习进度和计划数据。\n\n' +
          '请同时选择是否清除做题记录：\n' +
          '• 点击"确定（清除记录）"：删除做题记录，从零开始\n' +
          '• 点击"取消（保留记录）"：保留做题记录，新计划将自动标记已完成题目',
          '重新制定计划',
          {
            confirmButtonText: '确定（清除记录）',
            cancelButtonText: '取消（保留记录）',
            distinguishCancelAndClose: true,
            type: 'warning'
          }
        )
        clearRecords = true
      } catch (action) {
        if (action === 'cancel') {
          clearRecords = false
        } else {
          return
        }
      }
      try {
        // 调用后端接口清除学习进度和计划数据
        // 优先从localStorage获取用户ID
        let userId = null
        try {
          const userInfo = JSON.parse(localStorage.getItem('userInfo'))
          userId = userInfo && userInfo.id
        } catch (e) {
          console.error('解析userInfo失败:', e)
        }

        // 如果localStorage没有，尝试从userForm获取
        if (!userId && this.userForm && this.userForm.id) {
          userId = this.userForm.id
        }

        if (!userId) {
          this.$message.error('无法获取用户ID，请重新登录')
          return
        }
        const { resetStudyPlan } = require('@/api/studyPlan')

        // 获取当前题库 ID：优先路由 query，其次 localStorage（由 AMCPlanDetails 写入）
        const q = (this.$route && this.$route.query) ? this.$route.query : {}
        const routeRepoId = q.repoId ? Number(q.repoId) : null
        const localRepoId = localStorage.getItem('current_repo_id') ? Number(localStorage.getItem('current_repo_id')) : null
        const repoId = routeRepoId || localRepoId || null

        const loading = this.$loading({
          lock: true,
          text: '正在清理学习数据...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        await resetStudyPlan(userId, repoId, clearRecords)
        loading.close()

        // 清除可能的缓存
        localStorage.removeItem('selectedAmcLevel')
        localStorage.removeItem('userAmcInfo')

        // 如果保留做题记录，需要在localStorage中标记，以便在重新制定计划时使用
        if (!clearRecords) {
          localStorage.setItem('preserveRecords', 'true')
        } else {
          localStorage.removeItem('preserveRecords')
        }

        this.$message.success(
          clearRecords
            ? '学习数据已清理，正在跳转到重新制定学习计划页面...'
            : '学习数据已清理（做题记录已保留），正在跳转到重新制定学习计划页面...'
        )
        setTimeout(() => {
          this.$router.replace({
            path: '/amc-level-select',
            query: {
              recreate: 'true',
              level: q.level,
              courseTypeId: q.courseTypeId,
              courseTypeCode: q.courseTypeCode
            }
          })
        }, 800)
      } catch (e) {
        console.error('重置AMC信息失败:', e)
        this.$message.error('重置计划失败，请重试')
      }
    },
    showDeleteAccountDialog() {
      if (!this.userForm.email) {
        this.$message.warning('请先绑定邮箱后再进行注销操作')
        return
      }
      this.deleteAccountDialogVisible = true
      this.deleteAccountForm.code = ''
    },
    handleDeleteAccountDialogClose() {
      if (this.deleteAccountLoading || this.deleteAccountCodeSending) {
        this.$message.warning('操作正在进行中，请稍候...')
        return
      }
      this.deleteAccountDialogVisible = false
      this.deleteAccountForm.code = ''
      if (this.$refs.deleteAccountForm) {
        this.$refs.deleteAccountForm.resetFields()
      }
    },
    async sendDeleteAccountCodeHandler() {
      if (!this.userForm.email) {
        this.$message.warning('请先绑定邮箱')
        return
      }
      this.deleteAccountCodeSending = true
      try {
        const res = await sendDeleteAccountCode()
        if (res.code === 1) {
          this.$message.success('验证码已发送至您的邮箱，请查收')
          this.deleteAccountCountdown = 60
          const timer = setInterval(() => {
            this.deleteAccountCountdown--
            if (this.deleteAccountCountdown <= 0) {
              clearInterval(timer)
            }
          }, 1000)
        } else {
          this.$message.error(res.msg || '验证码发送失败')
        }
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.$message.error('验证码发送失败，请重试')
      } finally {
        this.deleteAccountCodeSending = false
      }
    },
    async submitDeleteAccount() {
      try {
        const valid = await this.$refs.deleteAccountForm.validate()
        if (!valid) {
          return
        }
        await this.$confirm(
          '确认要注销账户吗？此操作将永久删除您的所有数据，无法恢复！',
          '最终确认',
          {
            confirmButtonText: '确认注销',
            cancelButtonText: '取消',
            type: 'error',
            confirmButtonClass: 'el-button--danger'
          }
        )
        this.deleteAccountLoading = true
        const res = await deleteAccount(this.deleteAccountForm.code)
        if (res.code === 1) {
          this.$message.success('账户注销成功')
          this.deleteAccountDialogVisible = false
          localStorage.clear()
          sessionStorage.clear()
          setTimeout(() => {
            this.$router.replace('/login')
          }, 1500)
        } else {
          this.$message.error(res.msg || '账户注销失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('注销账户失败:', error)
          this.$message.error('账户注销失败，请重试')
        }
      } finally {
        this.deleteAccountLoading = false
      }
    }
  }
}
</script>

<style scoped>
.amc-profile-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.profile-card {
  width: 100%;
  max-width: 700px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-header .title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.header-actions {
  display: flex;
  gap: 10px;
}

.header-amc-bar {
  display: flex;
  justify-content: center;
  gap: 32px;
  padding: 14px 16px;
  margin: 0 20px;
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.12) 0%, rgba(64, 158, 255, 0.06) 100%);
  border-radius: 10px;
}

.header-amc-item {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.header-amc-label {
  font-size: 12px;
  color: #909399;
}

.header-amc-value {
  font-size: 16px;
  font-weight: 700;
  color: #409eff;
}

.profile-content {
  padding: 20px 0;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}

.amc-info-section {
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
  border-radius: 8px;
}

.amc-info-row {
  display: flex;
  gap: 40px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.info-item .label {
  font-size: 12px;
  color: #909399;
}

.info-item .value {
  font-size: 18px;
  font-weight: 600;
  color: #409eff;
}

.user-form {
  max-width: 500px;
  margin: 0 auto;
}

.avatar-container {
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.user-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
}

.avatar-container:hover .user-avatar {
  border-color: #409eff;
  transform: scale(1.05);
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  font-size: 12px;
}

.avatar-container:hover .avatar-overlay {
  opacity: 1;
}

.avatar-overlay i {
  font-size: 20px;
  margin-bottom: 4px;
}

.avatar-overlay span {
  font-size: 11px;
}

.delete-account-dialog {
  padding: 10px 0;
}

/* 购买状态样式 */
.status-paid {
  color: #67c23a !important;
}

.status-unpaid {
  color: #f56c6c !important;
}

.purchase-tip {
  margin: 0 20px 20px;
}

.purchase-tip p {
  margin: 0;
  line-height: 1.6;
}

.org-bind-row {
  display: flex;
  gap: 10px;
}

.org-bind-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}

.org-binding-list {
  margin-top: 12px;
  width: 100%;
}

.org-empty {
  padding: 12px 14px;
  border-radius: 8px;
  background: #f5f7fa;
  color: #909399;
}

.org-binding-item {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 10px;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  background: #f9fbff;
}

.org-binding-main {
  flex: 1;
}

.org-binding-name {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 6px;
}

.org-binding-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 12px;
  color: #606266;
  line-height: 1.6;
}

.org-binding-time {
  flex-shrink: 0;
  font-size: 12px;
  color: #909399;
}

/* 积分样式 */
.points-item {
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 12px;
  border-radius: 8px;
}

.points-item:hover {
  background: rgba(255, 215, 0, 0.1);
}

.points-value {
  color: #e6a23c !important;
}

.points-value i {
  margin-right: 4px;
}

.recharge-btn {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 12px;
  color: #fff;
  background: linear-gradient(135deg, #ffd700 0%, #ffb347 100%);
  border-radius: 10px;
  cursor: pointer;
}

.recharge-btn:hover {
  opacity: 0.9;
}
</style>
